import {
    ICustomerStoreEventHandler,
    ParcelScannedParameters,
    ParcelStoreCancelledParameters,
    SendReceiptConfirmedParameters
} from './ICustomerStoreEventHandler';
import {
    CommercialInvoiceRequest,
    GetReceiptRequest,
    ScanRequest,
    UpsRestClient
} from '../../rest-clients/UpsRestClient';
import {DateTime} from 'luxon';
import {logger} from '../../logger';
import {toT} from "@variocube/cube-ui";

const log = logger.sub("UpsCustomerStoreEventHandler");

export class UpsCustomerStoreEventHandler implements ICustomerStoreEventHandler {
    async parcelScanned(params: ParcelScannedParameters): Promise<void> {
        log.info(`Called ups customer parcel scanned event handler for ${params.parcelId}`);
        const { baseUrl, token } = params.backendApiCredentials;
        const upsRestClient = new UpsRestClient(baseUrl, token, params.cubeId);
        const t = toT(params.strings);
        const commercialInvoiceRequest: CommercialInvoiceRequest = {
            trackingNumber: params.parcelId,
        };
        const commercialInvoiceResponse = await upsRestClient.getCommercialInvoice(commercialInvoiceRequest);
        if (commercialInvoiceResponse?.ok && commercialInvoiceResponse.body?.commercialInvoiceIndication) {
            params.setMessage?.({
                message: t("UpsCommercialInvoiceDescription"),
                title: t("UpsCommercialInvoiceTitle"),
                cancel: params.cancelToHomeScreen,
                confirm: () => params.setMessage?.(undefined),
                disableAutoClose: true,
            });
        }

        const scanRequest: ScanRequest = {
            event: 'SHIPPER_DROP_OFF',
            scanDateTime: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss.SSS'),
            trackingNumber: params.parcelId,
        };

        const scanResponse = await upsRestClient.sendScanEvent(scanRequest);

        if (!scanResponse.ok || !scanResponse.body.success) {
            throw new Error(JSON.stringify(scanResponse.body));
        }
    }

    async parcelStoreCancelled(params: ParcelStoreCancelledParameters): Promise<void> {
        log.info(`Called ups customer parcel store cancelled event handler for ${params.parcelId}`);
        const { baseUrl, token } = params.backendApiCredentials;
        const upsRestClient = new UpsRestClient(baseUrl, token, params.cubeId);

        const request: ScanRequest = {
            event: 'SHIPPER_RECOVERY',
            scanDateTime: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss.SSS'),
            trackingNumber: params.parcelId,
        };

        const response = await upsRestClient.sendScanEvent(request);

        if (!response.ok || !response.body.success) {
            throw new Error(JSON.stringify(response.body));
        }
    }

    async sendReceiptConfirmed(params: SendReceiptConfirmedParameters): Promise<void> {
        log.info(`Called ups customer parcel store cancelled event handler for ${params.parcelId}`);
        const { baseUrl, token } = params.backendApiCredentials;
        const upsRestClient = new UpsRestClient(baseUrl, token, params.cubeId);

        const request: GetReceiptRequest = {
            requestType: params.email ? 'EMAIL' : 'SMS',
            requestedDate: DateTime.now().toFormat('dd.MM.yyyy'),
            serviceType: 'DROPOFF',
            trackingInfoList: [{ trackingNumber: params.parcelId }],
            langCodes: [params.language],
            emailAddress: params.email,
            phoneNumber: params.phone,
        };

        const response = await upsRestClient.getReceipt(request);

        if (!response.ok || !response.body.success) {
            throw new Error(JSON.stringify(response.body));
        }
    }
}